<template>
    <div class="help">
        <el-dialog title="帮助中心" :visible.sync="dialogVisible" width="982px" :before-close="dialogHandleClose">
            <div class="main">
                <div class="tabs">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="使用教程" name="first"></el-tab-pane>
                        <el-tab-pane label="问题汇总" name="second"></el-tab-pane>
                    </el-tabs>
                    <div class="search" v-show="activeName == 'second'">
                        <el-form :inline="true" class="demo-form-inline">
                            <el-form-item>
                                <el-input v-model="searchVal" placeholder="搜索相关问题" size="small" clearable></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onReset" plain size="small">重置</el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="getResult" size="small">查询</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="content">
                    <div class="menu">
                        <el-menu :default-active="active" class="el-menu-vertical-demo" @select="handleSelect" unique-opened>
                            <el-submenu index="1">
                                <template slot="title">
                                    <span>营销玩法</span>
                                </template>
                                <el-menu-item-group>
                                    <el-menu-item index="拼团">拼团</el-menu-item>
                                    <el-menu-item index="订单返现">订单返现</el-menu-item>
                                    <el-menu-item index="接龙购">接龙购</el-menu-item>
                                </el-menu-item-group>
                            </el-submenu>
                        </el-menu>
                    </div>
                    <div class="text" v-if="activeName == 'first'">
                        <div v-if="info">
                            <h3>{{ info.code }}</h3>
                            <span class="date">{{ info.create_time }}</span>
                            <div v-html="info.content"></div>
                        </div>
                        <div v-else>
                            <el-empty description="暂无文章！"></el-empty>
                        </div>
                    </div>
                    <div class="text" v-else>
                        <div v-if="dataList.length > 0">
                            <el-collapse v-model="activeNames">
                                <el-collapse-item v-for="(item, index) in dataList" :key="index" :title="item.title" :name="index">
                                    <div v-html="item.content"></div>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                        <div v-else>
                            <el-empty description="暂无文章！"></el-empty>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer"> </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            activeNames: [],
            searchVal: "",
            activeName: "first",
            dialogVisible: false,
            active: "",
            info: null,
            dataList: [],
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
            getArticle: "activity/getArticle",
            getArticleCategory: "activity/getArticleCategory",
        }),
        // 初始化所选tab
        handleClick() {
            this.active = "拼团";
            this.getResult();
        },
        // 获取文章列表或文章
        getResult() {
            let params = {
                token: this.getToken,
            };
            let url;
            if (this.activeName == "first") {
                params.code = this.active + "教程";
                url = this.getArticle;
            } else {
                params.code = this.active;
                params.keyword = this.searchVal;
                url = this.getArticleCategory;
            }
            url(params).then(({ data }) => {
                if (data.code == 1) {
                    if (this.activeName == "first") {
                        this.info = data.data;
                    } else {
                        this.dataList = data.data.filter((item) => {
                            return item.code.indexOf("教程") == -1;
                        });
                    }
                }
            });
        },
        dialogHandleClose() {
            this.dialogVisible = false;
            this.active = "";
            this.activeName = "first";
            this.activeNames = [];
        },
        handleSelect(key, keyPath) {
            this.active = key;
            this.getResult();
        },
        onReset() {
            this.searchVal = "";
            this.getResult();
        },
    },
};
</script>

<style lang="scss" scoped>
.help {
    .main {
        flex: 1;
        display: flex;
        flex-direction: column;
        .tabs {
            border-bottom: 10px solid #f0f0f0;
            position: relative;
            .el-form {
                position: absolute;
                right: 0;
                top: -10px;
            }
        }
        .content {
            flex: 1;
            display: flex;
            height: 100%;
            max-height: 430px;
            .menu {
                border-right: 1px solid#e6e6e6;
                width: 200px;
                flex-shrink: 0;
                height: 100%;
                overflow-y: auto;
                &::-webkit-scrollbar {
                    display: none;
                }
                .el-menu {
                    height: 100%;
                    border: none;
                }
            }
            .text {
                width: 100%;
                padding: 20px;
                height: 100%;
                overflow-y: auto;
                &::-webkit-scrollbar-track-piece {
                    background: #d3dce6;
                }

                &::-webkit-scrollbar {
                    width: 6px;
                }

                &::-webkit-scrollbar-thumb {
                    background: #99a9bf;
                    border-radius: 20px;
                }
                h3 {
                    font-weight: bold;
                    color: #333333;
                    line-height: 56px;
                }
                span {
                    font-size: 12px;
                    font-weight: 400;
                    color: #999999;
                    line-height: 56px;
                }
                h4 {
                    font-size: 14px;
                    font-weight: bold;
                    color: #333333;
                    line-height: 56px;
                }
                p {
                    font-size: 14px;
                    font-weight: 400;
                    color: #666666;
                    line-height: 24px;
                    margin-bottom: 24px;
                }
            }
        }
    }
    ::v-deep .el-tabs__header {
        margin-bottom: 0;
    }
    ::v-deep .el-dialog__body {
        height: 520px !important;
        padding: 20px !important;
        display: flex;
        flex-direction: column;
    }
}
</style>